module.exports = __webpack_public_path__ + "img/asset11.85264c9f.png";